module.exports = __webpack_public_path__ + "img/reflashing.1084d532.gif";